import React from 'react';
import _ from 'lodash';
import Joi from 'joi-browser';
import UrgencyContactApi from '../../../services/workers/urgencyContact/UrgencyContactApi';
import UrgencyContactService from '../../../services/workers/urgencyContact/UrgencyContactService';
import { CcusMasterService } from '../../../services/CcusMasters';
import SessionStorageService from '../../../services/utilities/SessionStorageService';

import { WorkerHeader } from '../header/WorkerHeader';
import UrgencyContactForm from '../form/UrgencyContactForm';
import Information from '../../modals/common/Information';
import Confirmation from '../../modals/common/Confirmation';
import ConfirmationSafetyDocItemDialog from '../dialog/ConfirmationSafetyDocItemDialog';
import { FetchCcusDescription } from '../../FetchCcusDescription';

import masterSlideLoader from '../../../utilities/masterSlideLoader';
import { messageUtility } from '../../../utilities/messageUtility';
import { validationByJoi } from '../../../utilities/commonValidation';
import {
  extractErrorMessage,
  getZendeskArticleUrl,
} from '../../../utilities/commonUtil';
import {
  deleteControlCode,
  isNullOrUndefinedOrEmptyStr,
} from '../../../utilities/stringUtil';
import EventMg, { EventType } from '../../../utilities/EventManager';

import {
  ENV_VARS,
  WORKER_TAB,
  WORKER_PAGE_STATUS,
  DIALOG_STATUS,
  SAFETY_DOC_ITEM_VALIDATE,
  ZENDESK_LINK_IDS,
  ZENDESK_URL_GUIDE,
} from '../../../utilities/constants';

import styles from '../../../styles/componentStyle/workerForm/workerForm.scss';
import { MoveLeftIcon } from '../../icons/MoveLeftIcon';

/**
 * 緊急連絡先ページ
 * @props {object}pageStatus:ページ情報 (詳細・編集)
 * @props {string}workerId:作業員ID
 * @props {string}companyId:会社ID
 */
export class UrgencyContact extends React.Component {
  state = {
    header: {
      // 作業員基本情報ヘッダー用プロパティ
      LinkButtonObject: {}, // 作業員一覧ページに戻るリンク (内容はbuttonObject)
      buttonObject: {}, // ボタン内容 (内容はbuttonObject)
    },
    headerButtonObject: {
      // ヘッダーで必要なモデル (詳細はWorkerHeader.jsxを参照)
      label: data.defaultButton.label, // テキスト
      className: data.defaultButton.className, // クラス名
      onClick: null, // 処理
    },
    dialogStatus: DIALOG_STATUS.disabled.id, // ダイアログ表示用ステータス
    informationModal: {
      // インフォメーションモーダル用プロパティ (ボタン1つ)
      message: null, // モーダルダイアログのメッセージ
    },
    validErrorMessage: {}, // バリデーションエラーメッセージ
    urgencyContact: {
      // 緊急連絡先用プロパティ
      worker_urgency_contact_addresses: {
        name: '',
        postal_code: '',
        prefectures: '',
        city_name: '',
        address1: '',
        address2: '',
        tel: '',
      },
      ccus_info: {}, // CCUSから取得した情報を格納する
    },
    comboBoxList: {
      relationship: {}, // 続柄情報を格納する
    }, // 続柄マスターデータ格納用リスト
    roanToChoseiFlg: false, // 労安からの遷移先が直接「作業員詳細」か、黒メニュー「作業員一覧」経由かを区別するフラグ
  };

  events = {};

  constructor(props) {
    super(props);

    this.updatingFlag = true; // 多重更新防止Flag

    if (
      !(
        props.pageStatus === WORKER_PAGE_STATUS.CONFIRM ||
        props.pageStatus === WORKER_PAGE_STATUS.EDIT
      )
    ) {
      throw new Error('UrgencyContact.jsx constructor props.pageStatus');
    }
    if (_.isUndefined(props.workerId)) {
      throw new Error('UrgencyContact.jsx constructor props.workerId');
    }
    if (_.isUndefined(props.companyId)) {
      throw new Error('UrgencyContact.jsx constructor props.companyId');
    }

    this.events.validate = this.validate.bind(this);
    this.events.setValueEmergency = this.setValueEmergency.bind(this);
    this.events.inputValueSearch = this.inputValueSearch.bind(this);
    this.events.setCCUSValues = this.setCCUSValues.bind(this);
    this.events.showCcusInfoTranscriptionAgreementDialog = this.showCcusInfoTranscriptionAgreementDialog.bind(
      this
    );
    this.state.roanToChoseiFlg = props.roanToChoseiFlg;

    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        this.state = this.createObjectForMoveToWorkerList(this.state);
        this.state = this.createConfirmPageHeaderButton(this.state);
        break;
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.state = this.createObjectForMoveToWorkerList(this.state);
        this.state = this.createEditPageHeaderButton(this.state);
        break;
      default:
        break;
    }
  }

  /**
   * React Component LifeCycle
   * マウントが行われた直後
   * */
  async componentDidMount() {
    const state = _.cloneDeep(this.state);
    const matchFormatPostalCodeHyphen = value => {
      return value.match(/^\d{3}-\d{4}$/) ? true : false;
    };
    if (this.props.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID) {
      const params = UrgencyContactService.createFetchRelationshipParam();
      // 続柄用のマスターデータを取得
      await CcusMasterService.relationship(params).then(response => {
        if (response.result === true) {
          const responseData = response.data.entities;
          state.comboBoxList.relationship = responseData.family_relationships;
        }
      });
    }

    // 緊急連絡先情報とCCUSの緊急連絡先情報を取得
    await UrgencyContactApi.fetchUrgencyContact(
      this.props.companyId,
      this.props.workerId
    ).then(response => {
      if (response.result) {
        state.urgencyContact.worker_urgency_contact_addresses =
          response.data.entities.worker_urgency_contact_addresses;

        const ccus_info =
          response.data.entities.ccus_worker_urgency_contact_addresses;
        // 郵便番号が正しい形ではない場合成形
        if (
          !_.isNull(ccus_info.postal_code) &&
          !matchFormatPostalCodeHyphen(ccus_info.postal_code)
        ) {
          ccus_info.postal_code = `${ccus_info.postal_code.slice(
            0,
            3
          )}-${ccus_info.postal_code.slice(3)}`;
        }
        state.urgencyContact.ccus_info = ccus_info;
      }
    });

    // CCUSから情報を取得ボタンを押された後の処理
    if (this.props.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID) {
      EventMg.addEventListener(EventType.FETCH_CCUS_INFO, async () => {
        // CCUS情報の再取得
        await UrgencyContactApi.fetchUrgencyContact(
          this.props.companyId,
          this.props.workerId
        ).then(response => {
          if (response.result) {
            const state = _.cloneDeep(this.state);
            const ccus_info =
              response.data.entities.ccus_worker_urgency_contact_addresses;
            // 郵便番号が正しい形ではない場合成形
            if (
              !_.isNull(ccus_info.postal_code) &&
              !matchFormatPostalCodeHyphen(ccus_info.postal_code)
            ) {
              ccus_info.postal_code = `${ccus_info.postal_code.slice(
                0,
                3
              )}-${ccus_info.postal_code.slice(3)}`;
            }
            state.urgencyContact.ccus_info = ccus_info;
            this.setState(state);
          }
        });
      });
    }

    this.setState(state, () => {
      this.updatingFlag = false; // 画面ロード後更新可能になる
    });
  }

  /**
   * React Component LifeCycle
   * コンポーネントがアンマウントされる時
   * */
  componentWillUnmount() {
    // アンマウントされる時にEventListenerを削除する
    EventMg.deleteEvent(EventType.FETCH_CCUS_INFO);
  }

  /**
   * =====================================================
   * ヘッダー周りの処理 - START
   * =====================================================
   */

  /**
   * buttonObjectを初期化する
   * @param {object} state: ステート
   * */
  clearButtonObject = state => {
    state.headerButtonObject.label = data.defaultButton.label;
    state.headerButtonObject.className = data.defaultButton.className;
    state.headerButtonObject.onClick = null;
    return state;
  };

  /**
   * 作業員一覧ページに戻るためのリンクを作成する
   * @param {object} state: ステート
   * */
  createObjectForMoveToWorkerList = state => {
    state.headerButtonObject.label = data.buttonLink.label;
    state.headerButtonObject.className = data.buttonLink.defaultClassName;
    state.headerButtonObject.onClick = this.handlerMoveToWorkerList.bind(this);
    state.header.LinkButtonObject.moveToWorkerList = _.cloneDeep(
      state.headerButtonObject
    );
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 詳細画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createConfirmPageHeaderButton = state => {
    // 編集ボタン作成
    state.headerButtonObject.label = data.header.confirm.button.edit.label;
    state.headerButtonObject.className =
      data.header.confirm.button.edit.className;
    state.headerButtonObject.onClick = this.moveToWorkerEdit.bind(this);
    state.header.buttonObject.cancel = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 編集画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createEditPageHeaderButton = state => {
    // 編集をやめるボタン作成
    state.headerButtonObject.label = data.header.edit.button.cancel.label;
    state.headerButtonObject.className =
      data.header.edit.button.cancel.className;
    state.headerButtonObject.onClick = this.showCancelEditDialog.bind(this);
    state.header.buttonObject.cancel = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);

    // 更新ボタン作成
    state.headerButtonObject.label = data.header.edit.button.update.label;
    state.headerButtonObject.className =
      data.header.edit.button.update.className;
    state.headerButtonObject.onClick = this.handlerUpdate;
    state.header.buttonObject.register = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 作業員一覧へ戻るリンクをクリックした時の処理
   * */
  handlerMoveToWorkerList = () => {
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.showLeaveThisPageDialog();
        break;
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        this.moveToWorkerList();
        break;
      default:
        break;
    }
  };

  /**
   * =====================================================
   * ヘッダー周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * 画面遷移周りの処理 - START
   * =====================================================
   */

  /**
   * 作業員一覧画面に遷移する
   */
  moveToWorkerList = () => {
    masterSlideLoader.show('Workers', { state: {} });
  };

  /**
   * 緊急連絡先詳細画面に遷移する
   */
  moveToWorkerConfirm = () => {
    if (this.state.roanToChoseiFlg) {
      SessionStorageService.setRoanToChoseiFlg(this.state.roanToChoseiFlg);
    }
    masterSlideLoader.show('WorkerConfirm', {
      state: {
        id: `${WORKER_TAB.URGENCY_CONTACT.TAB_NAME},${this.props.workerId}`,
      },
    });
  };

  /**
   * 緊急連絡先編集画面に遷移する
   */
  moveToWorkerEdit = () => {
    if (this.state.roanToChoseiFlg) {
      SessionStorageService.setRoanToChoseiFlg(this.state.roanToChoseiFlg);
    }
    masterSlideLoader.show('WorkerEdit', {
      state: {
        id: `${WORKER_TAB.URGENCY_CONTACT.TAB_NAME},${this.props.workerId}`,
      },
    });
  };

  /**
   * =====================================================
   * 画面遷移周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * ダイアログ周りの処理 - START
   * =====================================================
   */

  /**
   * ダイアログを閉じる
   * */
  closeDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    state.informationModal.message = null;
    this.setState(state);
  };

  /**
   * 編集をやめるダイアログを表示する
   * */
  showCancelEditDialog = () => {
    let state = { ...this.state };
    state.dialogStatus = DIALOG_STATUS.cancelEditDialogEnabled.id;
    this.setState(state);
  };

  /**
   * ページを移動する旨を示すダイアログを表示する
   * */
  showLeaveThisPageDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.leaveThisPageDialogEnabled.id;
    this.setState(state);
  };

  /**
   * CCUS情報をすべて転記することに同意するかを確認するダイアログを表示する
   * */
  showCcusInfoTranscriptionAgreementDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus =
      DIALOG_STATUS.ccusInfoTranscriptionAgreementDialogEnabled.id;
    this.setState(state);
  };

  /**
   * CCUS情報をすべて転記することに同意するかを確認するダイアログを閉じる
   * */
  closeCcusInfoTranscriptionAgreementDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    this.setState(state, () => this.setCCUSValues());
  };

  /**
   * =====================================================
   * ダイアログ周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * API周りの処理 - START
   * =====================================================
   */

  /**
   * 緊急連絡先登録・更新
   */
  updateUrgencyContact() {
    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    const stateValue = _.cloneDeep(this.state);
    if (this.validate()) {
      const params = UrgencyContactService.createUpdateUrgencyContactParam(
        stateValue.urgencyContact
      );
      UrgencyContactApi.updateUrgencyContact(
        this.props.companyId,
        this.props.workerId,
        params
      )
        .then(response => {
          if (response.result === true) {
            this.updatingFlag = false;
            this.moveToWorkerConfirm();
            return;
          }

          stateValue.dialogStatus = DIALOG_STATUS.updateFailedDialogEnabled.id;
          stateValue.informationModal.message = extractErrorMessage(response);
          this.updatingFlag = false;
          this.setState(stateValue);
        })
        .catch(error => {
          stateValue.dialogStatus = DIALOG_STATUS.updateFailedDialogEnabled.id;
          stateValue.informationModal.message = extractErrorMessage(error);
          this.updatingFlag = false;
          this.setState(stateValue);
        });
    }
  }

  /**
   * =====================================================
   * API周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   *フォーム周りの処理 - START
   * =====================================================
   */

  /**
   * 緊急連絡先の情報をセット
   * @param {string} name：セット対象のキー名
   * @param {string} value：セットするデータ
   */
  setValueEmergency = (name, value) => {
    value = deleteControlCode(value);
    const urgencyContact = _.cloneDeep(this.state.urgencyContact);
    const { worker_urgency_contact_addresses } = urgencyContact;
    worker_urgency_contact_addresses[name] = value;
    const val = { ...urgencyContact, worker_urgency_contact_addresses };
    this.setState({ urgencyContact: val });
  };

  /**
   * CCUS情報を転記する
   * @param {string} name 転記対象のキー名 指定がない場合は全項目を転記する
   * */
  setCCUSValues = name => {
    const state = _.cloneDeep(this.state);
    if (name) {
      const ccusVal = state.urgencyContact.ccus_info[name];
      if (isNullOrUndefinedOrEmptyStr(ccusVal) === false) {
        // CCUSの値がある場合は転記
        state.urgencyContact.worker_urgency_contact_addresses[name] = ccusVal;
        // BLDE_V2-38465: 「続柄」転記の場合はコード値もコピーする
        if (name === 'relationship') {
          const relationship_code =
            state.urgencyContact.ccus_info['relationship_code'];
          // マスタにない値の場合はnullのため、"0"で登録する
          if (relationship_code) {
            state.urgencyContact.worker_urgency_contact_addresses[
              'relationship_code'
            ] = relationship_code;
          } else {
            state.urgencyContact.worker_urgency_contact_addresses[
              'relationship_code'
            ] = '0';
          }
        }
      }
    } else {
      _.map(state.urgencyContact.ccus_info, (val, key) => {
        if (isNullOrUndefinedOrEmptyStr(val) === false) {
          state.urgencyContact.worker_urgency_contact_addresses[key] = val;
        }
      });
    }
    this.setState(state, () => {
      this.validate(name);
    });
  };

  /**
   * TODO 要解析 ひとまずWorkerFormから移しただけ、最適化などは可能なはず
   */
  setOneDropDown(key, data, keyInFormValues) {
    this.setState(prevState => ({
      ...prevState,
      urgencyContact: {
        ...prevState.urgencyContact,
        [keyInFormValues]: {
          ...prevState.urgencyContact[keyInFormValues],
          ...data,
        },
      },
    }));
  }

  /**
   * TODO 要解析 ひとまずWorkerFormから移しただけ、最適化などは可能なはず
   * @description 入力値をコンボボックスから検索
   * @param {array} targetValues 該当項目の入力値
   * @param {array} comboBoxList コンボボックスリスト
   * @param {string} value 入力値
   * @param {int} index 要素数 ※コンボボックスの複数入力が行えない場合、-1をセット
   * @param {object} keyParams キーパラメータ
   */
  inputValueSearch(targetValues, comboBoxList, value, index, keyParams) {
    const matchItem = _.find(
      comboBoxList,
      item => item[keyParams.searchKey] === value
    );
    if (index >= 0) {
      targetValues[index] = {
        ...targetValues[index],
        [keyParams.codeKey]: _.isUndefined(matchItem)
          ? '0'
          : matchItem[keyParams.codeKey],
        [keyParams.searchKey]: value,
      };
      if (!_.isUndefined(keyParams.codeKeyL)) {
        targetValues[index] = {
          ...targetValues[index],
          [keyParams.codeKeyL]: _.isUndefined(matchItem)
            ? '0'
            : matchItem[keyParams.codeKeyL],
        };
      }
      this.setJobValues(keyParams.targetKey, targetValues, keyParams.blockKey);
    } else {
      targetValues = {
        [keyParams.codeKey]: _.isUndefined(matchItem)
          ? '0'
          : matchItem[keyParams.codeKey],
        [keyParams.searchKey]: value,
      };
      if (!_.isUndefined(keyParams.codeKeyL)) {
        targetValues[index] = {
          ...targetValues[index],
          [keyParams.codeKeyL]: _.isUndefined(matchItem)
            ? '0'
            : matchItem[keyParams.codeKeyL],
        };
      }
      this.setOneDropDown(
        keyParams.targetKey,
        targetValues,
        keyParams.blockKey
      );
    }
  }

  /**
   * バリデーション
   * @param {string} keyName
   * @return {boolean} バリデート結果
   */
  validate = keyName => {
    const stateValue = _.cloneDeep(this.state);
    const validateSchema = UrgencyContactService.createValidateSchema();

    const result = validationByJoi(
      Joi.object().keys(validateSchema),
      UrgencyContactService.createUpdateUrgencyContactParam(
        stateValue.urgencyContact
      )
    );

    //メッセージ作成
    if (isNullOrUndefinedOrEmptyStr(keyName) === false) {
      if (_.has(result.messages.worker_urgency_contact_addresses, keyName)) {
        stateValue.validErrorMessage[keyName] =
          result.messages.worker_urgency_contact_addresses[keyName];
      } else {
        stateValue.validErrorMessage[keyName] = '';
      }
    } else {
      //全体でバリデート
      if (result.status === false) {
        stateValue.validErrorMessage = Object.assign(
          stateValue.validErrorMessage,
          result.messages.worker_urgency_contact_addresses
        );
      } else {
        stateValue.validErrorMessage = {};
      }
    }

    this.setState(stateValue);
    return result.status;
  };

  validateAllSafetyDocItem = () => {
    const urgencyContact = this.state.urgencyContact
      .worker_urgency_contact_addresses;

    const schema = UrgencyContactService.createSafetyDocItemSchema();

    const result = validationByJoi(schema, urgencyContact);
    return result;
  };

  getSafetyDocItemErrorMessage = messages => {
    const errorPropertyList = [];
    for (let key of Object.keys(messages)) {
      let constName = undefined;
      switch (key) {
        default:
          constName = Object.values(
            SAFETY_DOC_ITEM_VALIDATE.URGENCY_CONTACT
          ).find(constValue => constValue.KEY === key);
          break;
      }
      if (!_.isUndefined(constName)) {
        errorPropertyList.push(constName.TEXT);
      }
    }
    return errorPropertyList;
  };

  showSafetyDocItemDialog = () => {
    this.setState({
      dialogStatus: DIALOG_STATUS.safetyDocItemErrorDialogEnabled.id,
    });
  };

  handlerUpdate = () => {
    const result = this.validateAllSafetyDocItem();
    if (result.status) {
      return this.updateUrgencyContact();
    }
    const errorPropertyList = this.getSafetyDocItemErrorMessage(
      result.messages
    );
    this.setState(
      {
        errorPropertyList,
      },
      () => {
        this.showSafetyDocItemDialog();
      }
    );
  };

  /**
   * =====================================================
   * フォーム周りの処理 - END
   * =====================================================
   */

  /**
   * CCUSから情報を取得するボタン・補足説明の表示
   */
  showFetchCcusDescription = () => {
    const REACT_APP_ZENDESK_URL = ENV_VARS.REACT_APP_ZENDESK_URL;
    if (this.props.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID) {
      if (this.props.isAgencyRegister) {
        if (!_.has(this.props.agencyInfo, 'in_upstream_ccus_field_trees')) {
          return;
        } else {
          // 代行先の作業員
          const canFetchCcus =
            this.props.isAlreadyCcusConnect &&
            this.props.agencyInfo.in_upstream_ccus_field_trees &&
            this.props.isLinkedUser;
          // BLDE_V2-50226 CCUS事業者IDは削除された場合に転記情報は表示されない
          if (canFetchCcus && !this.props.isCcusJigyousyaDeleted) {
            if (isNullOrUndefinedOrEmptyStr(this.props.linkedToCcusDate)) {
              return (
                <FetchCcusDescription
                  description={messageUtility.getMessage('I-000-161')}
                  onClick={() => this.props.callFetchCcusWorkersData()}
                />
              );
            } else {
              return (
                <FetchCcusDescription
                  description={messageUtility.getMessage('I-000-162')}
                  linkedToCcusDate={this.props.linkedToCcusDate}
                  onClick={() => this.props.callFetchCcusWorkersData()}
                />
              );
            }
          } else {
            return (
              // 代行先のCCUSに登録された詳細情報はCCUSの制限により取得できません。<br>Buildeeに直接入力を行ってください。
              <FetchCcusDescription
                description={
                  <span>
                    CCUSから情報を取得することができません。赤字の条件が満たされていません。
                    <br />
                    CCUSから代行先の情報を取得するには、下記の条件をすべて満たす必要があります。
                    <br />
                    <br />
                    <ul className='fetch-ccus-description-message__text-list'>
                      {/* BLDE_V2-50226 CCUS事業者IDは削除された場合に文言は赤色になる */}
                      {/* BLDE_V2-50623 代行先会社はCCUSと連携されているかどうかによって文言の色は変更する */}
                      <li
                        className={
                          this.props.isCcusJigyousyaConnected &&
                          this.props.isAlreadyCcusConnect &&
                          !this.props.isCcusJigyousyaDeleted
                            ? ''
                            : 'text--negative'
                        }
                      >
                        <span className='fetch-ccus-description-message__text'>
                          {messageUtility.getMessage('I-000-263')}
                        </span>
                      </li>
                      <li
                        className={
                          this.props.isLinkedUser ? '' : 'text--negative'
                        }
                      >
                        <span className='fetch-ccus-description-message__text'>
                          あなたのアカウントが代行先の連携ユーザーとして設定されている
                        </span>
                        {!this.props.isLinkedUser && (
                          <span>
                            （
                            <span
                              className='clickable-text'
                              onClick={() => {
                                masterSlideLoader.show('PrimeCcusPreview', {
                                  state: { id: this.props.companyId },
                                });
                              }}
                            >
                              こちら
                            </span>
                            から設定してください）
                          </span>
                        )}
                      </li>
                      <li
                        className={
                          this.props.agencyInfo.in_upstream_ccus_field_trees
                            ? ''
                            : 'text--negative'
                        }
                      >
                        <span className='fetch-ccus-description-message__text'>
                          施工体制のCCUS連携を行っているいずれかの現場で、代行先の会社があなたの会社の下位協力会社として登録されている
                        </span>
                        {!this.props.agencyInfo
                          .in_upstream_ccus_field_trees && (
                          <span>
                            （詳細は
                            <a
                              className='clickable-text'
                              href={`${getZendeskArticleUrl(
                                REACT_APP_ZENDESK_URL,
                                ZENDESK_LINK_IDS.CCUS_FIELD_TREES
                              )}`}
                              target='_blank'
                              rel='noopener noreferrer'
                            >
                              こちら
                            </a>
                            をご確認ください。）
                          </span>
                        )}
                      </li>
                    </ul>
                  </span>
                }
                disabledCcusConnectionButton
              />
            );
          }
        }
      }
      //  BLDE_V2-50226 CCUS事業者IDは削除された場合に転記情報は表示されない
      if (
        (this.props.isAlreadyCcusConnect &&
          this.props.isCcusJigyousyaDeleted) ||
        !this.props.isCcusJigyousyaConnected
      ) {
        return null;
      }
      if (
        !this.props.isLinkedUser ||
        !this.props.ccusEngineerId ||
        !this.props.isAlreadyCcusConnect
      ) {
        return (
          <FetchCcusDescription
            disabledCcusConnectionButton
            description={
              <div>
                <p>
                  CCUSから情報を取得することができません。赤字の条件が満たされていません。
                </p>
                <p>
                  CCUSから情報を取得するには、下記の条件をすべて満たす必要があります。
                </p>
                <ul className='fetch-ccus-description-message__text-list'>
                  <li
                    className={!this.props.isLinkedUser ? 'text--negative' : ''}
                  >
                    <span className='fetch-ccus-description-message__text'>
                      あなたのアカウントが自社の連携ユーザーとして設定されている
                    </span>
                    {!this.props.isLinkedUser && (
                      <span>
                      （
                      <span
                        className='clickable-text'
                        onClick={() => {
                          masterSlideLoader.show('PrimeCcusPreview', {
                            state: { id: this.props.companyId },
                          });
                        }}
                      >
                        こちら
                      </span>
                        から設定してください）
                      </span>
                    )}
                  </li>
                  <li
                    className={
                      !this.props.ccusEngineerId ||
                      !this.props.isAlreadyCcusConnect
                        ? 'text--negative'
                        : ''
                    }
                  >
                    <span className='fetch-ccus-description-message__text'>
                      作業員の基本情報タブにCCUS技能者IDが登録されておりCCUS連携に成功している
                    </span>
                  </li>
                </ul>
                <br />
                <p>
                  作業員のCCUS連携の手順は
                  <a
                    className='clickable-text'
                    href={ZENDESK_URL_GUIDE.CCUS_WORKER_WARNING}
                    target='_blank'
                    rel='noreferrer noopener'
                  >
                    こちら
                  </a>
                  をご確認ください。
                </p>
              </div>
            }
          />
        );
      }
      if (isNullOrUndefinedOrEmptyStr(this.props.linkedToCcusDate)) {
        return (
          <FetchCcusDescription
            description={messageUtility.getMessage('I-000-161')}
            onClick={() => this.props.callFetchCcusWorkersData()}
          />
        );
      } else {
        return (
          <FetchCcusDescription
            description={messageUtility.getMessage('I-000-162')}
            linkedToCcusDate={this.props.linkedToCcusDate}
            onClick={() => this.props.callFetchCcusWorkersData()}
          />
        );
      }
    }
  };

  // 画面表示
  render() {
    return (
      <React.Fragment>
        <WorkerHeader
          LinkButtonObject={this.state.header.LinkButtonObject}
          buttonObject={this.state.header.buttonObject}
          errorMessagesCount={
            Object.values(this.state.validErrorMessage).filter(v => v !== '')
              .length
          }
        />
        <div className='contruction-detail-view__bar' />

        <UrgencyContactForm
          ccusDescription={this.showFetchCcusDescription()} /* CCUSから情報を取得するボタン・補足説明 */
          events={this.events}
          messages={this.state.validErrorMessage}
          formValues={this.state.urgencyContact}
          disabledAll={this.props.pageStatus.DISABLED_ALL}
          comboBoxList={this.state.comboBoxList}
          isCcusJigyousyaDeleted={this.props.isCcusJigyousyaDeleted} // BLDE_V2-50226 CCUS事業者IDは削除されたかどうか決断
        />

        {/* 更新失敗時のダイアログ */}
        <Information
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.updateFailedDialogEnabled.id
          }
          title={messageUtility.getMessage('E-000-005')}
          message={this.state.informationModal.message}
          buttonText={messageUtility.getMessage('I-000-008')}
          onClose={this.closeDialog}
        />

        {/* 編集をやめる時のダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus === DIALOG_STATUS.cancelEditDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-025')}
          confirmButtonText={messageUtility.getMessage('I-000-025')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-050')}
          isNegative
          onConfirm={() => this.moveToWorkerConfirm()}
          onCancel={() => this.closeDialog()}
        />

        {/* 作業員一覧へ戻る時のダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.leaveThisPageDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-051')}
          confirmButtonText={messageUtility.getMessage('I-000-053')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-052')}
          isNegative
          onConfirm={() => this.moveToWorkerList()}
          onCancel={() => this.closeDialog()}
        />

        {/* CCUS全て転記ダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.ccusInfoTranscriptionAgreementDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-164')}
          confirmButtonText={messageUtility.getMessage('I-000-165')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={
            <React.Fragment>
              {messageUtility.getMessage('I-000-166')}
              <MoveLeftIcon className='form-list__element-ccus-icon' />
              {messageUtility.getMessage('I-000-167')}
            </React.Fragment>
          }
          isNegative
          negativeButtonClassName='btn'
          rootClassName={styles.CcusInfoTranscriptionAgreementDialog}
          onConfirm={() => this.closeCcusInfoTranscriptionAgreementDialog()}
          onCancel={() => this.closeDialog()}
        />

        <ConfirmationSafetyDocItemDialog
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.safetyDocItemErrorDialogEnabled.id
          }
          errorPropertyList={this.state.errorPropertyList}
          onConfirm={() => {
            this.setState({ dialogStatus: DIALOG_STATUS.disabled.id }, () => {
              this.updateUrgencyContact();
            });
          }}
          onCancel={() => {
            this.setState({ dialogStatus: DIALOG_STATUS.disabled.id });
          }}
        />
      </React.Fragment>
    );
  }
}

// 定数
const data = {
  buttonLink: {
    label: '作業員一覧',
    defaultClassName: 'btn-text--sm',
  },
  defaultButton: {
    label: '',
    className: 'btn',
  },
  header: {
    confirm: {
      button: {
        edit: {
          label: '編集',
          className: 'btn',
        },
      },
    },
    edit: {
      button: {
        cancel: {
          label: '編集をやめる',
          className: 'btn--sub',
        },
        update: {
          label: '更新',
          className: 'btn--effective',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/worker/page/UrgencyContact.jsx